export const style = {
  button: {
    sx: {
      mt: 1,
    },
  },
};
